import type { Slice } from '@reduxjs/toolkit';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { AxiosRequestConfig } from 'axios';

import { isProd, isTalkie } from '../utils/env';
import type { RootState } from './rootReducers';
import { postGetWebMirrorConfig } from '../api/mirror';

export enum MirrorExperiment {
  CHAT_V2,
}

const MapMirrorName = {
  [MirrorExperiment.CHAT_V2]: 'CHAT_V2',
};

const MirrorIdMap = {
  [MirrorExperiment.CHAT_V2]: {
    // 星野
    x: {
      prod: 2807,
      dev: 2563,
    },
    // talkie
    t: {
      prod: 4002265,
      dev: 4002110,
    },
  },
} as const;

function getMirrorId(experiment: MirrorExperiment): number {
  const environment = isProd ? 'prod' : 'dev';
  const mode = isTalkie ? 't' : 'x';
  return MirrorIdMap[experiment][mode][environment];
}

const MapMirrorId = {
  [MirrorExperiment.CHAT_V2]: getMirrorId(MirrorExperiment.CHAT_V2),
};

export interface IMirrorState {
  configs: {
    [MirrorExperiment.CHAT_V2]?: { enable_new_ugc_chat_v2?: '1' } | null;
  };
}

const initialState: IMirrorState = { configs: {} };

export const getMirrorConfig = createAsyncThunk(
  'mirror/getMirrorConfig',
  async (
    {
      params,
    }: {
      params: { experiment: MirrorExperiment };
      config?: AxiosRequestConfig;
    },
    { rejectWithValue, getState }
  ) => {
    const {
      user: { authData },
    } = getState() as RootState;
    try {
      const res = await postGetWebMirrorConfig(
        { group_id: MapMirrorId[params.experiment], exper_name: MapMirrorName[params.experiment] },
        { params: { authData } }
      );
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const mirrorSlice: Slice<IMirrorState> = createSlice({
  name: 'mirror',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMirrorConfig.fulfilled, (state, action) => {
        state.configs[action.meta.arg.params.experiment] =
          (action.payload.mirrorConfig as any) || null;
      })
      .addCase(getMirrorConfig.rejected, (state, action) => {
        console.error('getRolePlayStoryInfo error', action.error);
      });
  },
});
